import {GameInfo} from '../../games/game-info';
import {ActiveFilter} from '../games-filter.service.interface';

export enum FilterType {
  categoryFilter = 1,
  featureFilter = 2
}

export interface IGameFilter {
  filterType: FilterType
  applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean
}
